import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

/** Android deep links sometimes use /plans&foo=bar instead of /plans?foo=bar */
function fixMalformedPlansDeepLink(): void {
  const { pathname, search, hash } = window.location;
  if (search || !pathname.includes('&')) {
    return;
  }
  const match = pathname.match(/^\/(plans|app-plans)(&.+)$/);
  if (!match) {
    return;
  }
  const query = match[2].slice(1);
  window.history.replaceState(null, '', `/${match[1]}?${query}${hash}`);
}

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
